import { createSlice } from "@reduxjs/toolkit";

import { setDeep } from "Libs/objectAccess";

import { getProjectAccessesThunk } from "./thunks/getProjectAccesses.thunk";

import type { ProjectAccess } from "@packages/client";

type State = {
  data: Record<string, Record<string, Array<ProjectAccess>>>;
  loading: Record<string, Record<string, boolean>>;
  error: Record<string, Record<string, boolean>>;
};

const initialState: State = {
  data: {},
  loading: {},
  error: {}
};

const projectAccesses = createSlice({
  name: "projectAccesses",
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(getProjectAccessesThunk.pending, (state, action) => {
      const { organizationId, project } = action.meta.arg;
      setDeep(state, ["loading", organizationId, project.id], true);
      setDeep(state, ["error", organizationId, project.id], false);
    });
    builder.addCase(getProjectAccessesThunk.fulfilled, (state, action) => {
      const { organizationId, project } = action.meta.arg;
      setDeep(state, ["data", organizationId, project.id], action.payload);
      setDeep(state, ["loading", organizationId, project.id], false);
    });
    builder.addCase(getProjectAccessesThunk.rejected, (state, action) => {
      const { organizationId, project } = action.meta.arg;
      setDeep(state, ["loading", organizationId, project.id], false);
      setDeep(state, ["error", organizationId, project.id], true);
    });
  }
});

export default projectAccesses.reducer;
